import React from 'react'
import { CHECKBOX, COMBO, NUMERO_DECIMALE, NUMERO_DECIMALE_NEGATIVO, NUMERO_INTERO, NUMERO_INTERO_NEGATIVO, RADIO, TESTO } from '../constants';
import Select from './Select';
import InputNumber from './InputNumber';
import InputText from './InputText';
import Radio from './Radio';
import Checkbox from './Checkbox';

const Domande = ({ domande, risposte, onChangeInputNumber, onChangeInputRadio, onChangeInputText, onChangeSelect, onChangeInputCheckbox }) => {
  return (
    domande.map((domanda, index) => {      
      switch (domanda.TIPO_RISPOSTA) {
        case COMBO:
          return (
            <Select key={index}
              item={domanda}
              kid={domanda.KID}
              domande={domande}
              risposte_all={risposte}
              value={domanda.val}
              onChange={onChangeSelect} />
          );
        case NUMERO_INTERO:
        case NUMERO_DECIMALE:
        case NUMERO_INTERO_NEGATIVO:
        case NUMERO_DECIMALE_NEGATIVO:
          return (
            <InputNumber key={index}            
              kid={domanda.KID}
              type={domanda.TIPO_RISPOSTA}
              item={domanda}
              domande={domande}
              risposte_all={risposte}
              value={domanda.val || ""}
              onChange={onChangeInputNumber} />
          )
        case TESTO:
          return (
            <InputText key={index}
              kid={domanda.KID}
              item={domanda}
              domande={domande}
              risposte_all={risposte}
              value={domanda.val || ""}
              onChange={onChangeInputText} />
          )
        case RADIO:
          return (
            <Radio key={index}
              kid={domanda.KID}
              item={domanda}
              domande={domande}
              risposte_all={risposte}
              value={domanda.val || ""}
              onChange={onChangeInputRadio} />
          )
        case CHECKBOX:
          return (
            <Checkbox key={index}
              kid={domanda.KID}
              item={domanda}
              domande={domande}
              risposte_all={risposte}
              value={domanda.val || ""}
              onChange={onChangeInputCheckbox} />
          )        
        default:
          return null;
      }
    })
  )
}

export default Domande